import {AnalyticsReporter} from '../core/AnalyticsReporter';
import type {AnalyticsConfig} from '../core/types';

export const createAnalyticsReporter = <T extends string>(
  config: AnalyticsConfig,
) => {
  return new AnalyticsReporter<T>(config);
};
